import SvgIcon from '@components/ui/svg-icon/svg-icon';
import { IconName as I } from '@components/ui/svg-icon/svg-icon';
export default SvgIcon;
export type IconName = I;
